import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes(
  'DATA_REQUEST',
  'ResolutionCenter/RemediatedIncidents'
)

export const SEARCH_CHANGE = 'ResolutionCenter/RemediatedIncidents/SEARCH_CHANGE'
export const SEARCH_RESET = 'ResolutionCenter/RemediatedIncidents/SEARCH_RESET'
export const PAGINATE_CHANGE = 'ResolutionCenter/RemediatedIncidents/PAGINATE_CHANGE'
export const GENERAL_FILTER_CHANGE = 'ResolutionCenter/RemediatedIncidents/GENERAL_FILTER_CHANGE'
export const DATE_FILTER_CHANGE = 'ResolutionCenter/RemediatedIncidents/DATE_FILTER_CHANGE'
export const SET_DETECTED_BY_FILTER = 'ResolutionCenter/RemediatedIncidents/SET_DETECTED_BY_FILTER'
export const SORTING_CHANGE = 'ResolutionCenter/RemediatedIncidents/SORTING_CHANGE'

export const NAME_FOR_HISTORY_STORE = 'remediatedIncidentsUserFilter'
